// src/app/footer/footer.js

import React, { useContext, useEffect } from 'react';
import { StateContext } from 'context';
import './footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram, faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { withRouter } from "react-router-dom";
import { Themes } from 'styles';
const Footer = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {
    }, [])

    return (
        <>
            <div id="footer" className="w3-block">
                <div className="w3-block" style={{backgroundColor: Themes[indexTema].D5}}>
                    <div className="w3-content" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
                        <div className="w3-row">
                            <div className="w3-col l8 bs-bbox col-copyright" style={{ paddingLeft: '16px', paddingBottom: '16px' }}>
                                <span>©2025 Servitravel SA. Todos los derechos reservados | Diseñado por <span className="font-lato-black">Servitravel SA</span></span>
                            </div>
                            <div className="w3-col l4 bs-bbox col-social-links">
                                {/* Corrected Line 24: Removed aria-hidden and title from icon, kept aria-label on anchor */}
                                <a href="https://www.facebook.com/ServiTravel" target="_blank" rel="noreferrer"  aria-label="Facebook"><FontAwesomeIcon icon={faFacebookSquare} color="#fff" size="2x"></FontAwesomeIcon></a>
                                {/* Corrected Line 25: Removed aria-hidden and title from icon, kept aria-label on anchor */}
                                <a href="https://www.instagram.com/servitravel/" target="_blank" rel="noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} color="#fff" size="2x"></FontAwesomeIcon></a>
                              { /* <a href="https://twitter.com/servitravel" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTwitterSquare} color="#fff" size="2x" aria-hidden="true" title="twitter"></FontAwesomeIcon></a> */}
                                {/* Corrected Line 27: Removed aria-hidden and title from icon, kept aria-label on anchor */}
                                <a href="https://wa.me/595986229400" aria-label="Whatsapp"><FontAwesomeIcon icon={faWhatsapp} color="#fff" size="2x"></FontAwesomeIcon></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(Footer);